import { decodeRoutes, isCompressedData } from '@wix/members-area-commons-ts';
import { type CreateControllerFn } from '@wix/yoshi-flow-editor';

import { globalAppState } from '../../../services/global-app-state';
import type { GlobalControllerConfig } from '../../../types';

const getConfigWithDecodedRoutes = (config: GlobalControllerConfig) => {
  const routes = config.appParams?.publicData?.APP?.routes;

  if (!routes || !isCompressedData(routes)) {
    return config;
  }

  const decodedRoutes = decodeRoutes(routes);

  config.appParams!.publicData!.APP!.routes = decodedRoutes;

  return config;
};

export const controllerMAV2: CreateControllerFn = async ({
  controllerConfig,
}) => {
  const _controllerConfig = controllerConfig as GlobalControllerConfig;
  const configWithDecodedRoutes = getConfigWithDecodedRoutes(_controllerConfig);
  globalAppState.setGlobalControllerConfig(configWithDecodedRoutes);

  return {
    async pageReady() {
      // We could return controllerConfig here and take it in exports
      // Need to speak with viewer about this, because it's not typed and not documented...
    },
  };
};
